var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoNot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi",
    viewBox: "42 34.46 178 142.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,211.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1829 1640 l-164 -140 -622 0 -623 0 0 -115 0 -115 481 0 c282 0 479 -4 477 -9 -1 -5 -85 -79 -185 -165 l-183 -156 -295 0 -295 0 0 -120 0 -119 152 -3 151 -3 -141 -120 -142 -120 43 -38 c23 -20 54 -46 69 -57 l26 -20 211 180 210 180 601 0 600 0 0 120 0 120 -457 2 -457 3 190 162 189 162 268 1 267 0 0 115 0 115 -125 0 c-69 0 -125 3 -124 8 0 4 41 41 90 82 l90 75 -53 48 c-86 77 -66 82 -249 -73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoNot);
export default __webpack_public_path__ + "static/media/do-not.19dad1ad05c491d114dc44616e1107b1.svg";
export { ForwardRef as ReactComponent };